import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { CaretDownIcon } from '@radix-ui/react-icons';
import { ElevatedButton } from '@producer/ui-kit';

import { VersionListItem } from './version-list-item';
import { Asset } from '../../../app/entities';

import styles from './version-selector.module.scss';

type VersionSelectorProps = {
  assetChildren: Asset[];
  version: number;
  onSelect: (version: Asset) => void;
  selectedAssetId?: string;
};

export const VersionSelector: React.FC<VersionSelectorProps> = ({
  assetChildren,
  version,
  onSelect,
  selectedAssetId,
}) => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <ElevatedButton text={`v${version}`} endIcon={<CaretDownIcon />} />
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content className={styles.list} sideOffset={5} align="start">
          {assetChildren.map((asset) => (
            <DropdownMenu.Item key={asset._id}>
              <VersionListItem
                onClick={() => onSelect(asset)}
                thumbnail={asset.cover?.src || asset.thumbnail}
                isSelected={selectedAssetId === asset._id}
                name={asset.name}
                version={asset.version || 1}
                date={asset.createdAt}
                uploader={asset.uploader?.firstName || ''}
                fileType={asset.fileType}
                extension={asset.extension}
              />
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
